<template>
    <div class="cashback-records-container">
        <div class="search-row">
            <el-input v-model="orderId" placeholder="请输入订单号" style="width: 300px; margin-right: 10px;"></el-input>
            <el-button type="primary" @click="search">查 询</el-button>
        </div>
        <el-table :data="tableData" border style="width: 100%; margin-top: 20px;">
            <el-table-column prop="amazonOrderId" label="亚马逊订单号" align="center"></el-table-column>
            <el-table-column prop="award" label="奖品名称" align="center"></el-table-column>
            <el-table-column prop="awardTime" label="中奖时间" align="center"></el-table-column>
            <el-table-column prop="claimTime" label="领奖时间" align="center"></el-table-column>
            <!-- <el-table-column prop="rid" label="领奖操作人ID" align="center"></el-table-column> -->
            <el-table-column prop="status" label="奖品状态" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.status == 1 ? '已中奖未领奖' : scope.row.status == 2 ? '已领奖' : '' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="150">
                <template slot-scope="scope">
                    <el-button type="text" v-if="scope.row.status == 1" @click="handleClaim(scope.row)">标记为已领奖</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from '../../api/api/api';

export default {
    name: 'CashbackRecords',
    data() {
        return {
            orderId: '',
            tableData: [],
            tableVisible: false
        }
    },
    methods: {
        handleClaim(row) {
            const roleText = localStorage.getItem('role');
            let rid = '';
            if(roleText){
                rid = JSON.parse(roleText).rid;
                ajaxPost(Baseurl + 'cashback/claim', { amazonOrderId: row.amazonOrderId, rid: rid }).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('操作成功');
                        this.search();
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            }
            
        },
        search() {
            // TODO: 调用接口查询
            console.log(this.orderId);
            ajaxPost(Baseurl + 'cashback/queryByOrder', { amazonOrderId: this.orderId }).then(res => {
                if(res.data.code == 200){
                    const d = res.data.data;
                    console.log(d);
                    if(d.type == 1){
                        console.log(d.data);
                        const PRIZE_MAP = {
                            'p1': '1美元返现',
                            'p2': '2美元返现',
                            'p3': '3美元返现',
                            'p4': '4美元返现',
                            'p5': '5美元返现',
                            'p6': '复购5%折扣',
                            'p7': '复购7%折扣',
                            'p8': '20美元返现',
                        };
                        this.tableData = [{
                            amazonOrderId: d.data.amazonOrderId,
                            award: PRIZE_MAP[d.data.award],
                            awardTime: d.data.awardTime,
                            claimTime: d.data.claimTime,
                            status: d.data.status,
                        }];
                    }else{
                        if(d.data){
                            this.$message.warning('单号不存在');
                        }else{
                            this.$message.warning('未抽奖');
                        }
                    }
                }
            })
            
        }
    }
}
</script>

<style scoped lang="scss">
.cashback-records-container {
    padding: 20px;

    .search-row {
        display: flex;
        align-items: center;
    }
}
</style>
